var map = {
	"./ShopVideoBlock": 535,
	"./ShopVideoBlock.js": 535,
	"./aboutCompetitionBlock": 542,
	"./aboutCompetitionBlock.js": 542,
	"./articleGallery": 516,
	"./articleGallery.js": 516,
	"./articleList": 550,
	"./articleList.js": 550,
	"./bioListBlock": 555,
	"./bioListBlock.js": 555,
	"./bioListItem": 577,
	"./bioListItem.js": 577,
	"./cardsContainerBlock": 543,
	"./cardsContainerBlock.js": 543,
	"./careSlider": 507,
	"./careSlider.js": 507,
	"./careSliderItem": 756,
	"./careSliderItem.js": 756,
	"./careculator": 556,
	"./careculator.js": 556,
	"./chatbotBlock": 527,
	"./chatbotBlock.js": 527,
	"./chatbotButton": 526,
	"./chatbotButton.js": 526,
	"./collageImageGridItemBlock": 530,
	"./collageImageGridItemBlock.js": 530,
	"./contactUsLocation": 839,
	"./contactUsLocation.js": 839,
	"./contactUsSearchBlock": 521,
	"./contactUsSearchBlock.js": 521,
	"./countdownTimerBlock": 544,
	"./countdownTimerBlock.js": 544,
	"./downloadBriefBlock": 545,
	"./downloadBriefBlock.js": 545,
	"./ecommerceBlock": 554,
	"./ecommerceBlock.js": 554,
	"./eventTemplate": 518,
	"./eventTemplate.js": 518,
	"./farmItem": 801,
	"./farmItem.js": 801,
	"./featureArticleHero": 512,
	"./featureArticleHero.js": 512,
	"./featureBlock": 557,
	"./featureBlock.js": 557,
	"./galleryCarousel": 506,
	"./galleryCarousel.js": 506,
	"./gridContainerBlock": 558,
	"./gridContainerBlock.js": 558,
	"./horizontalGalleryBlock": 559,
	"./horizontalGalleryBlock.js": 559,
	"./horizontalScrollBlock": 560,
	"./horizontalScrollBlock.js": 560,
	"./horizontalYoutubeGalleryBlock": 561,
	"./horizontalYoutubeGalleryBlock.js": 561,
	"./hotspotBlock": 562,
	"./hotspotBlock.js": 562,
	"./hubGrid": 505,
	"./hubGrid.js": 505,
	"./hubHero": 502,
	"./hubHero.js": 502,
	"./imageSlider": 514,
	"./imageSlider.js": 514,
	"./imageSliderItem": 757,
	"./imageSliderItem.js": 757,
	"./instagramBlock": 515,
	"./instagramBlock.js": 515,
	"./iwpApplicationForm": 563,
	"./iwpApplicationForm.js": 563,
	"./judgeItemBlock": 578,
	"./judgeItemBlock.js": 578,
	"./judgesContainerBlock": 546,
	"./judgesContainerBlock.js": 546,
	"./keyDateItemBlock": 840,
	"./keyDateItemBlock.js": 840,
	"./magnifyingGallery": 519,
	"./magnifyingGallery.js": 519,
	"./myAccountUpdateProfilePage": 564,
	"./myAccountUpdateProfilePage.js": 564,
	"./navigator": 520,
	"./navigator.js": 520,
	"./newsTemplate": 513,
	"./newsTemplate.js": 513,
	"./newsroomBlock": 565,
	"./newsroomBlock.js": 565,
	"./pageFilter": 508,
	"./pageFilter.js": 508,
	"./parallaxFullWidthBlock": 566,
	"./parallaxFullWidthBlock.js": 566,
	"./productItemCarouselWidget": 553,
	"./productItemCarouselWidget.js": 553,
	"./productItemWidget": 121,
	"./productItemWidget.js": 121,
	"./profileDetailBlock": 539,
	"./profileDetailBlock.js": 539,
	"./profileListingBlock": 536,
	"./profileListingBlock.js": 536,
	"./profileListingItemBlock": 498,
	"./profileListingItemBlock.js": 498,
	"./provenceMap": 772,
	"./provenceMap.js": 772,
	"./provenceMapSlider": 511,
	"./provenceMapSlider.js": 511,
	"./quoteBlock": 567,
	"./quoteBlock.js": 567,
	"./readingTab": 510,
	"./readingTab.js": 510,
	"./renewalForm": 522,
	"./renewalForm.js": 522,
	"./searchBar": 758,
	"./searchBar.js": 758,
	"./shopFeaturedGridItemBlock": 531,
	"./shopFeaturedGridItemBlock.js": 531,
	"./shopItemsCarouselWidget": 552,
	"./shopItemsCarouselWidget.js": 552,
	"./shopItemsWidget": 551,
	"./shopItemsWidget.js": 551,
	"./shopListingBlock": 534,
	"./shopListingBlock.js": 534,
	"./shopListingByCategoryBlock": 533,
	"./shopListingByCategoryBlock.js": 533,
	"./shopListingProductBlock": 495,
	"./shopListingProductBlock.js": 495,
	"./shopProductBlock": 532,
	"./shopProductBlock.js": 532,
	"./siteFooter": 523,
	"./siteFooter.js": 523,
	"./siteFooterSitemap": 525,
	"./siteFooterSitemap.js": 525,
	"./siteFooterWoolLab": 524,
	"./siteFooterWoolLab.js": 524,
	"./siteHeader": 503,
	"./siteHeader.js": 503,
	"./siteHeaderWoolLab": 504,
	"./siteHeaderWoolLab.js": 504,
	"./socialBar": 517,
	"./socialBar.js": 517,
	"./sourcingGuideBlock": 538,
	"./sourcingGuideBlock.js": 538,
	"./sourcingGuideItemBlock": 500,
	"./sourcingGuideItemBlock.js": 500,
	"./stepByStepContainerBlock": 548,
	"./stepByStepContainerBlock.js": 548,
	"./stepByStepItemBlock": 547,
	"./stepByStepItemBlock.js": 547,
	"./supplierListingBlock": 537,
	"./supplierListingBlock.js": 537,
	"./supplierListingItemBlock": 499,
	"./supplierListingItemBlock.js": 499,
	"./tabContainer": 529,
	"./tabContainer.js": 529,
	"./tabbedPartnerContainerBlock": 541,
	"./tabbedPartnerContainerBlock.js": 541,
	"./textFeature": 509,
	"./textFeature.js": 509,
	"./timelineCarousel": 528,
	"./timelineCarousel.js": 528,
	"./upcomingEventsContainerBlock": 549,
	"./upcomingEventsContainerBlock.js": 549,
	"./videoBlock": 501,
	"./videoBlock.js": 501,
	"./videoListingBlock": 540,
	"./videoListingBlock.js": 540,
	"./welcomeBannerModal": 568,
	"./welcomeBannerModal.js": 568,
	"./woolLabImageBlock": 569,
	"./woolLabImageBlock.js": 569,
	"./woolLabInteractiveMoodboardBlock": 570,
	"./woolLabInteractiveMoodboardBlock.js": 570,
	"./woolLabMyMoodboardsBlock": 571,
	"./woolLabMyMoodboardsBlock.js": 571,
	"./woolLabMySwatchesBlock": 572,
	"./woolLabMySwatchesBlock.js": 572,
	"./woolLabOnboardingBlock": 573,
	"./woolLabOnboardingBlock.js": 573,
	"./woolLabPersistentSwatchDrawer": 574,
	"./woolLabPersistentSwatchDrawer.js": 574,
	"./woolLabRenameMoodboardModalBlock": 759,
	"./woolLabRenameMoodboardModalBlock.js": 759,
	"./woolLabSaveToMoodboardModalBlock": 592,
	"./woolLabSaveToMoodboardModalBlock.js": 592,
	"./woolLabShareSwatchModalBlock": 605,
	"./woolLabShareSwatchModalBlock.js": 605,
	"./woolLabSwatchBlock": 497,
	"./woolLabSwatchBlock.js": 497,
	"./woolLabSwatchDetailModalBlock": 496,
	"./woolLabSwatchDetailModalBlock.js": 496,
	"./woolLabSwatchLibraryHelpModalBlock": 764,
	"./woolLabSwatchLibraryHelpModalBlock.js": 764,
	"./woolLabSwatchLibrarySearchBlock": 575,
	"./woolLabSwatchLibrarySearchBlock.js": 575,
	"./woolLabThemesBlock": 576,
	"./woolLabThemesBlock.js": 576
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 897;